import { Reveal, Eyebrow } from "@/components/Reveal";
import { IMAGES } from "@/data/site";

const MACHINES = [
    "2 fresatrici CNC a 3 assi",
    "2 presse",
    "Trapani",
    "Sega per metalli",
    "Saldatrice",
    "Rettifica centesimale",
    "Fresa manuale",
    "Tornio",
    "Attrezzatura da banco",
];

const EquipmentItem = ({ name, index }) => (
    <li
        data-testid={`equipment-item-${index}`}
        className="group flex items-center gap-6 py-5 transition-colors duration-300 hover:bg-white"
    >
        <span className="w-10 shrink-0 pl-2 font-mono-tl text-sm text-tl-orange">
            {String(index + 1).padStart(2, "0")}
        </span>
        <span className="font-display text-lg font-semibold tracking-tight text-tl-ink sm:text-xl">{name}</span>
        <span className="ml-auto hidden h-px flex-1 bg-tl-ink/10 sm:block" />
        <span className="mr-2 hidden font-mono-tl text-[10px] uppercase tracking-[0.25em] text-tl-mutedDark sm:block">
            Officina
        </span>
    </li>
);

const EquipmentIntro = () => (
    <div>
        <Reveal delay={0.1}>
            <h2 className="font-display text-2xl font-bold tracking-tight text-tl-ink sm:text-3xl lg:text-4xl">
                Tecnologia e attrezzature<span className="text-tl-orange">.</span>
            </h2>
        </Reveal>
        <Reveal delay={0.18}>
            <p className="mt-6 max-w-md text-base leading-relaxed text-tl-mutedDark">
                Disponiamo di un parco macchine e di attrezzature che ci permettono di affrontare diverse
                tipologie di lavorazioni meccaniche.
            </p>
        </Reveal>
        <Reveal delay={0.24}>
            <div className="relative mt-10 hidden lg:block">
                <div className="absolute -left-3 -top-3 h-full w-full border border-tl-orange/50" />
                <img
                    src={IMAGES.officina}
                    alt="Officina meccanica con macchine utensili per lavorazioni su ferro e alluminio, Lecco"
                    loading="lazy"
                    className="relative h-64 w-full object-cover grayscale-[15%]"
                />
            </div>
        </Reveal>
    </div>
);

export default function Attrezzature() {
    return (
        <section id="attrezzature" data-testid="attrezzature-section" className="bg-tl-light2 py-20 md:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
                <Reveal>
                    <Eyebrow number="03" label="Attrezzature" dark />
                </Reveal>
                <div className="mt-6 grid gap-12 lg:grid-cols-[1fr_1.15fr] lg:gap-20">
                    <EquipmentIntro />
                    <ul className="divide-y divide-tl-ink/10 border-y border-tl-ink/10">
                        {MACHINES.map((m, i) => (
                            <Reveal key={m} delay={0.05 * i} y={16}>
                                <EquipmentItem name={m} index={i} />
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
